import React, {useEffect, useState} from 'react';

import {MODAL_SEARCH_PARAM_KEY} from '../../../website-ui/constants/url';
import AthletesSideModal from '../components/athletes-side-modal';

export default function withAthletesSideModal(WrappedComponent) {
  return props => {
    const [data, setData] = useState({isOpen: false, props: {}});

    useEffect(() => {
      const popStateHandler = currentData => () => {
        if (currentData.isOpen) {
          setData({isOpen: false, props: {}});
        }
      };

      const handler = popStateHandler(data);

      window.addEventListener('popstate', handler);
      return () => window.removeEventListener('popstate', handler);
    }, [data]);

    useEffect(() => {
      const url = new URL(window.location.href);
      const id = url.searchParams.get(MODAL_SEARCH_PARAM_KEY);

      const kindOfSport = props.list.find(sportItem => sportItem.id === id);

      if (kindOfSport) {
        setData({isOpen: true, props: kindOfSport});
      }
    }, [props.list, setData]);

    return (
      <>
        <WrappedComponent
          toggleSideModal={setData}
          {...props}
        />
        {data.isOpen && (
          <AthletesSideModal
            {...data.props}
            toggleSideModal={setData}
            withSportImages={props.withSportImages}
            themeColor={props.themeColor}
            pathToSportIcons={props.pathToSportIcons}
            pathToAthletPhotos={props.pathToAthletPhotos}
            backButtonModalClassName={props.backButtonModalClassName}
            athletNameModalClassName={props.athletNameModalClassName}
            backButtonIconModalClassName={props.backButtonIconModalClassName}
            backButtonTextModalClassName={props.backButtonTextModalClassName}
            modalContentClassName={props.modalContentClassName}
            sportInfoModalClassName={props.sportInfoModalClassName}
            athletModalClassName={props.athletModalClassName}
            athletImageExtension={props.athletImageExtension}
          />
        )}
      </>
    );
  };
}
